function PanTopViewBF(vars) {
  const viewName = 'TOP VIEW';
  const { p5, defaults: { dashedLine } } = this;

  const {
    lineOverflow, cornerLineLength,
    innerMeasureMargin, panLineMargin,
  } = specConfig;

  const {
    panWidth, panDepth, circleDrain, drainX,
    drainY, splashWallWidth, drainPosition,
    grateStyle, grateDepth, grateThickness,
  } = vars;

  const { state: {
    panWidthInches, panDepthInches, splashWallWidthInches, scale,
  } } = this;

  // Draw outer pan line
  rect(0, 0, panWidth, panDepth);

  // Draw inner pan line
  rect(
    splashWallWidth,
    splashWallWidth,
    panWidth - (splashWallWidth * 2),
    panDepth - splashWallWidth,
  );

  // Pan back slash wall measurement line
  line(panWidth + panLineMargin, 0, panWidth + cornerLineLength, 0);

  // Pan entrance measurement line
  line(panWidth + panLineMargin, panDepth, panWidth + cornerLineLength, panDepth);

  // Left Splash Wall measurement line
  // line(0, panDepth + panLineMargin, 0, panDepth + cornerLineLength);
  line(0, -(panLineMargin), 0, -(cornerLineLength));

  // Right Splash Wall measurement line
  // line(panWidth, panDepth + panLineMargin, panWidth, panDepth + cornerLineLength);
  line(panWidth, -(panLineMargin), panWidth, -(cornerLineLength));

  // View Label
  strokeWeight(0);
  fill(0);
  text(
    viewName,
    (panWidth / 2) - (this._getTextWidth(viewName) / 2),
    panDepth + 55,
  );
  noFill();
  strokeWeight(1);

  // Drain
  translate(drainX, drainY);
  circle(0, 0, circleDrain);
  circle(0, 0, circleDrain - (scale * 0.75));

  // Drain target line
  drawingContext.setLineDash(dashedLine);

  // Drawing lines out from center
  // Line A
  line(0, 0, (panWidth - drainX) + lineOverflow, 0);
  line(0, 0, -(drainX + lineOverflow), 0);

  // Line B
  line(0, 0, 0, (panDepth - drainY) + lineOverflow);
  line(0, 0, 0, -(drainY + lineOverflow));

  drawingContext.setLineDash([]);

  this._createArrow(-(drainX + lineOverflow), -10, 'up'); // Left A
  this._createArrow(-10, -(drainY + lineOverflow), 'left'); // Top B

  this._createArrow((panWidth - drainX) + lineOverflow, -10, 'up'); // Right A
  this._createArrow(-10, (panDepth - drainY) + lineOverflow, 'left'); // Bottom B

  textSize(16);
  text('A', -(drainX + lineOverflow + 6), -22);
  text('A', (panWidth - drainX) + 5, -22);
  text('B', -32, -(drainY + lineOverflow - 5));
  text('B', -32, (panDepth - drainY) + lineOverflow + 7);

  // Edge Lines - Drain
  strokeWeight(1);
  line(panWidth - drainX + panLineMargin + 5, 0, (panWidth - drainX) + innerMeasureMargin, 0);

  line(
    0,
    -(drainY + innerMeasureMargin),
    0,
    -(drainY + panLineMargin + 5),
  );

  textSize(14);

  // Depth Measurement Line
  this._createMeasureLine(
    (panWidth - drainX) + cornerLineLength - 5,
    -(drainY),
    (panWidth - drainX) + cornerLineLength - 5,
    panDepth - drainY,
    this.state.panDepthInches,
  );

  // Depth Drain Line
  this._createMeasureLine(
    (panWidth - drainX) + innerMeasureMargin - 5,
    -(drainY),
    (panWidth - drainX) + innerMeasureMargin - 5,
    0,
    this.state.drainBackDistanceInches,
  );

  // Width Line
  this._createMeasureLine(
    -(drainX),
    -(drainY + cornerLineLength - 5),
    panWidth - drainX,
    -(drainY + cornerLineLength - 5),
    this.state.panWidthInches,
  );

  // Width Drain Line
  const drainSideXStart = (drainPosition === 'Left') ? -(drainX) : 0;
  const drainSideXEnd = (drainPosition === 'Left') ? 0 : panWidth - drainX;

  this._createMeasureLine(
    drainSideXStart,
    -(drainY + innerMeasureMargin - 5),
    drainSideXEnd,
    -(drainY + innerMeasureMargin - 5),
    this.state.drainSideDistanceInches,
  );

  // Trench grate
  if (grateStyle === 'Trench') {
    if (drainPosition === 'Back') {
      this._createBackTrenchGrate(panWidthInches - (splashWallWidthInches * 2), vars);
    } else {
      this._createTrenchGrate(
        panDepthInches - splashWallWidthInches,
        { ...vars, ...{ curbWidth: 0 } },
      );
    }
  }
}

